import { DialogService, GridAction } from '@eforall/dashboard';
import { AccVentureEntrepreneur } from '@interfaces';
import { PersonDialog } from '../../../../person-dialog';
import { VideoDialog, VideoDialogData } from '../../../video-dialog';
import { AccVentureDialogDataService } from '../../acc-venture-dialog-data.service';

export function getActions(dialogService: DialogService, dialogDataService: AccVentureDialogDataService) {

	const actions: GridAction<AccVentureEntrepreneur>[] = [
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View Person Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(PersonDialog, { data: { personId: rows[0]!.personId, toEdit: false } }, 800, 800);
			}
		},
		{
			iconClass: 'fa-regular fa-video',
			label: 'View Video',
			isEnabled: rows => !!rows.length && !!rows[0] && !!rows[0].uniqueVideoId,
			execute: async rows => {
				const r = rows[0]!;
				const dialogData: VideoDialogData = {
					type: 'applicationParticipant',
					personId: r.personId,
					uniqueVideoId: r.uniqueVideoId! // we know it's defined because of isEnabled
				};
				await dialogService.showCustom(VideoDialog, { data: dialogData }, 500, 550);
			}
		},
		{
			iconClass: 'fa-regular fa-times',
			label: 'Remove Entrepreneur',
			isEnabled: rows => dialogDataService.canEdit() && !!rows.length,
			execute: async rows => {
				const data = dialogDataService.dialogData();
				if (!data) return;

				const agree = await dialogService.confirm('Are you sure you want to remove the selected entrepreneur from this venture?');
				if (agree) await dialogDataService.removeEntrepreneur(rows[0]!.accEntrepreneurId, rows[0]!.personId, data.accVentureId);
			}
		},
	];

	return actions;
}